export default __webpack_public_path__ + "static/media/dimitard_l.7acfe64a.jpg";